import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import { rtkQueryErrorHandler } from 'utils/errorHandler';
import { baseApi } from './api/baseApi';
import authReducer from './slices/authSlice';
import fieldsFormReducer from './slices/fieldsFormSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    fieldsForm: fieldsFormReducer,
    [baseApi.reducerPath]: baseApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({}).concat([baseApi.middleware, rtkQueryErrorHandler])
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
